import { Injectable } from '@angular/core';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private sessionService: SessionService) { }

  public setAuthRole(role: string) {
    this.sessionService.setRole(role);
  }

  public isCoordinator(): boolean {
    if (this.sessionService.getRole() !== null) {
      return this.sessionService.getRole().toUpperCase() === 'COORDINATOR';
    }
  }

  public isDirector(): boolean {
    if (this.sessionService.getRole() !== null) {
      return this.sessionService.getRole().toUpperCase() === 'DIRECTOR';
    }
  }

  public isStaff(): boolean {
    if (this.sessionService.getRole() !== null) {
      return this.sessionService.getRole().toUpperCase() === 'STAFF';
    }
  }

  public changeAuthorized(): boolean {
      return (this.isDirector() || this.isCoordinator());
  }

  public isAuthorized(): boolean {
    return (this.changeAuthorized() || this.isStaff());
  }
}
